export default __webpack_public_path__ + "static/media/p21.af7329c1.jpg";